import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { propBool, propFunc } from '../../../../../helpers/custom-prop-types';
const SearchFilterHead = (props) => {
    const { isPsSlide, isSeminar, isShowFilter, isSlide, toggleFilter } = props;
    const headText = useMemo(() => {
        let text = '経験業界で絞り込む';
        if (isSeminar) {
            text = 'テーマで絞り込む';
        }
        if (isSlide || isPsSlide) {
            text = 'スライド種別で絞り込む';
        }
        return text;
    }, [isPsSlide, isSeminar, isSlide]);
    return (_jsx("div", Object.assign({ className: 'search_list_filter_head', onClick: toggleFilter, role: 'presentation' }, { children: _jsxs("div", Object.assign({ className: 'search_list_filter_head_row' }, { children: [_jsx("span", { children: headText }), _jsx("i", Object.assign({ className: 'material-icons' }, { children: isShowFilter ? 'keyboard_arrow_left' : 'keyboard_arrow_right' }))] })) })));
};
SearchFilterHead.propTypes = {
    isPsSlide: propBool().isRequired,
    isSeminar: propBool().isRequired,
    isShowFilter: propBool().isRequired,
    isSlide: propBool().isRequired,
    toggleFilter: propFunc().isRequired,
};
export default SearchFilterHead;
